<template>
  <v-tab
    class="valkyrie-tab"
    active-class="active"
  >
    <v-icon
      v-if="icon"
      class="ma-1 tab-icon"
      size="18"
    >
      {{ icon }}
    </v-icon>
    <span class="tab-text">{{ text }}</span>
  </v-tab>
</template>

<script>
  export default {
    name: 'ValkyrieTab',
    props: {
      icon: String,
      text: String,
    },
  }
</script>

<style lang="scss" scoped>
  .valkyrie-tab {
    padding: 13px 20px;
    & .tab-text, .tab-icon {
      color: $base !important;
    }
  }
  .active {
    & .tab-text, .tab-icon {
      color: $muted !important;
    }
  }
  .tab-text {
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
</style>
